import * as Utils from './savanna_utils.js';

export async function updateLeaveRequestCount()
{
	Utils.showLoader();
	let res = await Grape.fetches.getJSON('/manager/get_leave_to_approve_count');
	if (res.status != 'ERROR')
	{
		if (res.count > 0)
		{
			$('#leave_approval_badge_count').show();
			$('#leave_approval_badge_count .badge_counter').html(res.count);
		}
		else
			$('#leave_approval_badge_count').hide();

		Utils.hideLoader();
	}
	else
	{
		Utils.hideLoader();
		console.error(res.message);
	}
}

export async function updateWizardNotDoneCount()
{
	Utils.showLoader();
	try {
		let res = await Grape.fetches.getJSON('/wizard/get_wizard_not_done_count');
		if (res)
		{
			if (res.count > 0)
			{
				$('#what_to_do_next').show();
				$('#what_to_do_next .badge_counter').html(res.count);
			}
			else
				$('#what_to_do_next').hide();

			Utils.hideLoader();
		}

	} catch (error) {
		console.error('error', error);
		Utils.hideLoader();
	};
}

export async function updateNotificationCount()
{
	Utils.showLoader();
	try {
		let res = await Grape.fetches.getJSON('/notifications/count/unread');
			if (res.status != 'ERROR')
			{
				if (res.unread > 0)
				{
					$('#notification_badge_count').show();
					$('#notification_badge_count .badge_counter').html(res.unread);
				}
				else 
					$('#notification_badge_count').hide();

				Utils.hideLoader();
			}
			else
				Utils.hideLoader();
	} catch (error) {
		console.error('error', error);
		Utils.hideLoader();
	}
}

export async function updateSystemCount()
{
	Utils.showLoader();
	//Count number of documents to approve and update navigation bar accordingly
	try {
		let res = await Grape.fetches.getJSON('admin/get_documents_to_approve_count');
		if (res.status != 'ERROR')
		{
			if (res.count > 0)
			{
				$('#document_approval_badge_count').show();
				$('#document_approval_badge_count .badge_counter').html(res.count);
			}
			else 
				$('#document_approval_badge_count').hide();

			Utils.hideLoader();
		}
	} catch (error) {
		console.error('error', error);
		Utils.hideLoader();
	}
}

export async function updateTimeToApproveCount()
{
	Utils.showLoader();
	try {
		let res = await Grape.fetches.getJSON('/time_management/get_time_to_approve_count');
		if (res.status != 'ERROR')
		{
			if (res.count > 0)
			{
				$('#time_approval_badge_count').show();
				$('#time_approval_badge_count_dropdown').show();
				$('#time_approval_badge_count .badge_counter').html(res.count);
				$('#time_approval_badge_count_dropdown .badge_counter').html(res.count);
			} else
			{
				$('#time_approval_badge_count').hide();
				$('#time_approval_badge_count_dropdown').hide();
			}
			Utils.hideLoader();
		} else
		{
			Utils.hideLoader();
		}
	} catch (error) {
		console.error('error', error);
		Utils.hideLoader();
	}
}